import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CARD_LIST_RESPONSE, CHECKOUT_PAYMENT_RESPONSE } from 'models/payments';

export interface PaymentType {
  openPaymentModal: boolean;
  openBuyCredits: boolean;
  paymentMethodId: string;
  paymentIntentId: string;
  openPaymentSuccess: boolean;
  listCards: CARD_LIST_RESPONSE[];
  dataCheckoutPayment: CHECKOUT_PAYMENT_RESPONSE;
  statusPayNow: string;
}

const initialState: PaymentType = {
  paymentMethodId: '',
  paymentIntentId: '',
  openPaymentModal: false,
  openBuyCredits: false,
  openPaymentSuccess: false,
  listCards: [],
  dataCheckoutPayment: {
    amount: 0,
    tax_amount: 0,
    total_amount: 0,
    balance: 0,
    is_can_purchase_package: false,
    adjustment_surcharges: [],
    payment_gateway_fee: null,
    additional_child_surcharge: null,
    odd_hour_surcharge: null,
    weekend_surcharge: null,
    public_holiday_surcharge: null,
  },
  statusPayNow: '',
};

const paymentSlice = createSlice({
  name: 'payment',
  initialState,
  reducers: {
    setOpenPaymentModal(state: PaymentType, action: PayloadAction<boolean>) {
      state.openPaymentModal = action.payload;
    },
    setOpenBuyCredits(state: PaymentType, action: PayloadAction<boolean>) {
      state.openBuyCredits = action.payload;
    },
    setOpenPaymentSuccess(state: PaymentType, action: PayloadAction<boolean>) {
      state.openPaymentSuccess = action.payload;
    },
    updatePaymentMethodId(state: PaymentType, action: PayloadAction<string>) {
      state.paymentMethodId = action.payload;
    },
    updatePaymentIntentId(state: PaymentType, action: PayloadAction<string>) {
      state.paymentIntentId = action.payload;
    },
    updateStatusPayNow(state: PaymentType, action: PayloadAction<string>) {
      state.statusPayNow = action.payload;
    },

    updateListCards(
      state: PaymentType,
      action: PayloadAction<CARD_LIST_RESPONSE[]>,
    ) {
      state.listCards = action.payload;
    },
    updateDataCheckoutPayment(
      state: PaymentType,
      action: PayloadAction<CHECKOUT_PAYMENT_RESPONSE>,
    ) {
      state.dataCheckoutPayment = action.payload;
    },
  },
});

// Actions
export const {
  setOpenPaymentModal,
  updatePaymentMethodId,
  updatePaymentIntentId,
  setOpenBuyCredits,
  setOpenPaymentSuccess,
  updateListCards,
  updateDataCheckoutPayment,
  updateStatusPayNow,
} = paymentSlice.actions;

export default paymentSlice.reducer;
